import { Routes } from "@angular/router";

import { AuthGuard } from "../core/guards/auth/auth-guard.service";

import { NotFoundComponent } from "../core/guards/not-found/not-found.component";
import { CoreComponent } from "../core/header/core.component";
import { LoginComponent } from "../core/authentication/login/login.component";
import { LogoutComponent } from "../core/authentication/logout/logout.component";
import { RegisterComponent } from "../core/authentication/register/register.component";
import { DevelopersComponent } from "../core/developers/developers.component";

import { ResumeComponent } from "./resume/resume.component";

import { HelpTabsComponent } from "./help/help-tabs.component";
import { EntranceHelpComponent } from "./help/entrance/entrance-help.component";
import { ExpenseHelpComponent } from "./help/expense/expense-help.component";
import { BankAccountHelpComponent } from "./help/bank-account/bank-account-help.component";

import { ConceptComponent } from "./concept/concept/concept.component";
import { ConceptListComponent } from "./concept/concept/concept-list.component";
import { ConceptTabsComponent } from "./concept/concept-tabs.component";
import { ConceptFamilyComponent } from "./concept/conceptfamily/conceptfamily.component";
import { ConceptFamilyListComponent } from "./concept/conceptfamily/conceptfamily-list.component";
import { ConceptContactComponent } from "./concept/conceptcontact/conceptcontact.component";
import { ConceptContactListComponent } from "./concept/conceptcontact/conceptcontact-list.component";

import { ContactListComponent } from "./contact/contact/contact-list.component";
import { ContactFormRouteComponent } from "../modules_v2/contacts/components/contact-form-route/contact-form-route.component";
import { ContactTabsComponent } from "./contact/contact-tabs.component";

import { PreinvoiceListComponent } from "./invoice/preinvoice/preinvoice-list.component";
import { PreinvoiceComponent } from "./invoice/preinvoice/preinvoice.component";

import { DeliveryNoteListComponent } from "./invoice/deliverynotes/deliverynote-list.component";
import { DeliveryNoteComponent } from "./invoice/deliverynotes/deliverynote.component";

import { FiscalTabsComponent } from "./fiscalidad/fiscal-tabs.component";
import { FiscalModelComponent } from "./fiscalidad/fiscalModels/fiscalModel.component";


import { BankAccountListComponent } from "./finanzas/bancos/bankaccount-list.component";
import { BankAccountComponent } from "./finanzas/bancos/bankaccount.component";

import { ContactBankAccountComponent } from "./contact/contactbankaccounts/contactbankaccount.component";
import { ContactBankAccountListComponent } from "./contact/contactbankaccounts/contactbankaccount-list.component";

import { InvoiceTabsComponent } from "./invoice/invoice-tabs.component";
import { InvoiceListIssuedComponent } from "./invoice/invoice/invoice-list-issued.component";

import { ExpenseTabsComponent } from "./expense/expense-tabs.component";
import { ExpenseComponent } from "./expense/expenses/expense.component";

import { SalaryComponent } from "./expense/salary/salary.component";

import { SelfEmployedComponent } from "./expense/selfemployed/selfemployed.component";


import { QRCodeComponent } from "./qr/qrcode.component";

import { UserTabsComponent } from "./user/user-tabs.component";
import { UserLogoComponent } from "./user/usercontact/userlogo.component";
import { ExpenseSelectorComponent } from "./expense/expenses/expense-selector.component";
import { ForgotComponent } from "../core/authentication/forgot/forgot.component";

import { FilesListComponent } from "./file/files-list.component";

import { SubscriptionComponent } from "./subscription/subscription.component";
import { UserBillingListComponent } from "./user/usercontact/userbilling-list.component";

import { AdminListComponent } from "./admin/users/admin-list.component";

import { InvestmentComponent } from "./investment/intangible-material/investment.component";
import { InvestmentListComponent } from "./investment/intangible-material/investment-list.component";

import { IrpfListComponent } from "./expense/expenses/irpf-list.component";
import { ContactImportComponent } from "./contact/contact/contact-import.component";
import { ConceptImportComponent } from "./concept/concept/concept-import.component";

import { TicketComponent } from "./invoice/tickets/ticket.component";
import { TicketListComponent } from "./invoice/tickets/ticket-list.component";

import { AdvancePaymentComponent } from "./expense/advancepayment/advancePayment.component";
import { AdvancePaymentListComponent } from "./expense/advancepayment/advancePayment-list.component";

import { CustomerAdvancePaymentFormV2Component } from "../modules_v2/income/customer-advance-payment/components/customer-advance-payment-form/customer-advance-payment-form.component";

import { PaymentCardListComponent } from "./finanzas/paymentcard/tarjeta-credito/paymentcard-list.component";
import { PaymentCardComponent } from "./finanzas/paymentcard/paymentcard.component";
import { DummyComponent } from "../shared/dummy.component";

import { NotificationListComponent } from "./notification/notification-list.component";
import { OcrHistoryComponent } from "./ocrHistory/ocrHistory.component";
import { AdminTabsComponent } from "./admin/admin-tabs.component";
import { AdminHelpListComponent } from "./admin/help/help-list.component";
import { AdminLogListComponent } from "./admin/log/log-list.component";
import { AdminEventListComponent } from "./admin/event/event-list.component";
import { AdminHelpComponent } from "./admin/help/help.component";
import { ConsultantComponent } from "./consultant/consultant.component";
import { IrpfInvoiceListComponent } from "./invoice/invoice/irpf-list.component";
import { UserStockComponent } from "./user/userStock/userStock.component";
import { CenterListComponent } from "./contact/center/center-list.component";
import { CenterComponent } from "./contact/center/center.component";
import { AdminContactListComponent } from "./admin/contact/admincontact-list.component";

import { BankChargesComponent } from "./expense/bankcharges/bankcharges.component";
import { ReconciliationComponent } from "./conciliation/reconciliation/reconciliation.component";
import { AccountingTabsComponent } from "./accounting/accounting-tabs.component";
import { AccountingMovementsListComponent } from "./accounting/movements/accounting-movements-list.component";
import { TaxesTabsComponent } from "./taxes/taxes-tabs.component";
import { AccountingProfitAndLossComponent } from "./accounting/reports/profitandloss/accounting-profitandloss.component";
import { AccountingBalanceSheetComponent } from "./accounting/reports/balancesheet/accounting-balancesheet.component";
import { AccountingAccountsListComponent } from "./accounting/accounting-accounts/accounting-accounts-list.component";
import { ControlStockComponent } from "./concept/controlstock/controlstock.component";
import { ControlStockListComponent } from "./concept/controlstock/controlstock-list.component";
import { ConceptStatisticsComponent } from "./concept/concept-statistics/concept-statistics.component";
import { ExpenseStatisticsComponent } from "./expense/expense-statistics/expense-statistics.component";
import { InvoiceStatisticsComponent } from "./invoice/invoices-statistics/invoices-statistics.component";
import { InvestmenttabsComponent } from "./investment/investment-tabs.component";
import { InvestmentInCompaniesListComponent } from "./investment/incompanies/investment-incompanies-list.component";
import { InvestmentFinancialListComponent } from "./investment/financial/investment-financial-list.component";
import { InvestmentPropertyListComponent } from "./investment/property/investment-property-list.component";
import { EmployeesComponent } from "./employees/employees.component";
import { FinanzastabsComponent } from "./finanzas/finanzas-tabs.component";
import { CreditosConEmpleadosListComponent } from "./finanzas/creditos-con-empleados/creditos-con-empleados-list.component";
import { CreditosConEmpleadosComponent } from "./finanzas/creditos-con-empleados/creditos-con-empleados.component";
import { CreditosListComponent } from "./finanzas/creditos/creditos-list.component";
import { CreditosComponent } from "./finanzas/creditos/creditos.component";
import { FinanciacionPrivadaListComponent } from "./finanzas/financiacion-privada/financiacion-privada-list.component";
import { FinanciacionPrivadaComponent } from "./finanzas/financiacion-privada/financiacion-privada.component";
import { FinanciacionPropiaListComponent } from "./finanzas/financiacion-propia/financiacion-propia-list.component";
import { FinanciacionPropiaComponent } from "./finanzas/financiacion-propia/financiacion-propia.component";
import { PrestamosListComponent } from "./finanzas/prestamos/prestamos-list.component";
import { PrestamosComponent } from "./finanzas/prestamos/prestamos.component";
import { PartnersequityComponent } from "./user/partnersequity/partnersequity.component";
import { PartnersListComponent } from "./user/partnersequity/partners/partners-list.component";
import { SocialCapitalListComponent } from "./user/partnersequity/social-capital/social-capital-list.component";
import { ReserveListComponent } from "./user/partnersequity/reserve/reserve-list.component";
import { RelatedCompaniesListComponent } from "./user/partnersequity/related-companies/related-companies-list.component";
import { BajasComponent } from "./employees/bajas/bajas.component";
import { TurnosComponent } from "./employees/turnos/turnos.component";
import { VacacionesComponent } from "./employees/vacaciones/vacaciones.component";
import { AsuntosPropiosComponent } from "./employees/asuntos-propios/asuntos-propios.component";

import { EfectivoListComponent } from "./finanzas/efectivo/efectivo-list.component";
import { PolizaCreditoListComponent } from "./finanzas/poliza-credito/poliza-credito-list.component";
import { CreditosTabsComponent } from "./finanzas/creditos-tabs/creditos-tabs.component";
import { PrestamosTabsComponent } from "./finanzas/prestamos-tabs/prestamos-tabs.component";
import { TarjetaDebitoListComponent } from "./finanzas/paymentcard/tarjeta-debito/tarjeta-debito-list.component";
import { SupportTicketsComponent } from "./supportTickets/tickets.component";
import { AdvancePaymentTabsComponent } from "./expense/advancepayment-tabs/advancepayment-tabs.component";
import { BailListComponent } from "./expense/bail/bail-list.component";
import { BailComponent } from "./expense/bail/bail.component";
import { GastosComponent } from "./employees/gastos/gastos.component";
import { AnnualSumaryTabsComponent } from "./taxes/annual-summary-tabs/annual-summary-tabs.component";
import { Model180Component } from "./taxes/model-180/model-180.component";
import { Model184Component } from "./taxes/model-184/model-184.component";
import { Model193Component } from "./taxes/model-193/model-193.component";
import { Model182Component } from "./taxes/model-182/model-182.component";
import { ReportTabsComponent } from "./accounting/reports/report-tabs/report-tabs.component";
import { ReportTotalComponent } from "./accounting/reports/report-total/report-total.component";
import { ReportCashFlowComponent } from "./accounting/reports/report-cash-flow/report-cash-flow.component";
import { ReportWorkingCapitalComponent } from "./accounting/reports/report-working-capital/report-working-capital.component";
import { ReportGrossMarginComponent } from "./accounting/reports/report-gross-margin/report-gross-margin.component";
import { ReportRatioComponent } from "./accounting/reports/report-ratio/report-ratio.component";
import { QuarterlyTaxReceiptListComponent } from "./taxes/quarterly-tax-receipt/quarterly-tax-receipt-list/quarterly-tax-receipt-list.component";
import { QuarterlyTaxReceiptComponent } from "./taxes/quarterly-tax-receipt/quarterly-tax-receipt.component";
import { AccountingSumasySaldosComponent } from "./accounting/reports/sumasysaldos/accounting-sumasysaldos.component";

// #region Gastos - IA
import { IAGastosComponent } from "./expense/ia/ia.component";
import { CorreosIAComponent } from "./expense/correos-ia/correos-ia.component";
// import { Model180Component } from './taxes/resumen-anual/model-180/model-180.component';
import { EmployeestabsComponent } from "./employees/employees-tabs.component";
import { UserExportComponent } from "./user/export/user-export.component";
import { AccountingImportComponent } from "./accounting/import/accounting-import.component";
import { AccountingExportComponent } from "./accounting/export/accounting-export.component";
import { FeeGuard } from "../guards/fee.guard";
import { WorkOrderListComponent } from "./invoice/preinvoice/work-order-list.component";
import { AdvisorListComponent } from "./advisor/advisor-list.component";
import { TiempoComponent } from "./employees/tiempo/tiempo.component";
// #endregion

import { FiscalClosureListComponent } from "./taxes/fiscal-closure/fiscal-closure-list/fiscal-closure-list.component";
import { SalesReportComponent } from "./concept/salesreport/salesreport.component";
import { ContactFormComponent } from "../modules_v2/contacts/components/contact-form/contact-form.component";
import { AdminVerifactuAuthorizationComponent } from "../modules_v2/admin/admin-verifactu-authorization/admin-verifactu-authorization.component";
// #region IA Chat
import { AnalisisIngresosComponent } from "../modules_v2/ia/components/analisis-ingresos/analisis-ingresos.component";
// #endregion
import { ChildUsersComponent } from "./employees/childUsers/child-users.component";
import { PermissionGuard } from "../guards/permission/permission.guard";
import { UnauthorizedComponent } from "../guards/permission/unauthorized.component";
import { ScheduleListComponent } from "./schedule/schedule-list.component";
import { BookingCalendarComponent } from "../modules_v2/booking/components/booking-calendar/booking-calendar.component";
import { BookingListComponent } from "../modules_v2/booking/components/booking-list/booking-list.component";
import { BookingReportsComponent } from "../modules_v2/booking/components/booking-reports/booking-reports.component";
import { BookingTabsComponent } from "../modules_v2/booking/booking-tabs.component";
import { RecurrentListV2Component } from "../modules_v2/income/recurrent/components/recurrent-list/recurrent-list.components";
import { RecurrentFormV2Component } from "../modules_v2/income/recurrent/components/recurrent-form/recurrent-form.components";
import { GrantListComponent } from "../modules_v2/income/grant/components/grant-list/grant-list.components";
import { GrantFormV2Component } from "../modules_v2/income/grant/components/grant-form/grant-form.component";
import { CustomerAdvancePaymentListComponent } from "../modules_v2/income/customer-advance-payment/components/customer-advance-payment-list/customer-advance-payment-list.components";
import { FinancialIncomeListV2Component } from "../modules_v2/income/financial-income/components/financial-income-list/financial-income-list.components";
import { FinancialIncomeFormV2Component } from "../modules_v2/income/financial-income/components/financial-income-form/financial-income-form.component";
import { BankAccountListV2Component } from "../modules_v2/finance/bank-account/components/bank-account-list/bank-account-list.components";
import { CashListComponent as CashListV2Component } from "../modules_v2/finance/cash/components/cash-list/cash-list.components";
import { CreditPolicyListComponent as CreditPolicyListV2Component } from "../modules_v2/finance/credit-policy/components/credit-policy-list/credit-policy-list.components";
import { DebitCardListV2Component } from "../modules_v2/finance/payment-card/components/debit-card-list/debit-card-list.components";
import { CreditCardListV2Component } from "../modules_v2/finance/payment-card/components/credit-card-list/credit-card-list.components";
import { LoanListComponent as LoanListV2Component } from "../modules_v2/finance/loan/components/loan-list/loan-list.components";
import { OwnFinancingListComponent as OwnFinancingListV2Component } from "../modules_v2/finance/own-financing/components/own-financing-list/own-financing-list.components";
import { PrivateFinancingListComponent as PrivateFinancingListV2Component } from "../modules_v2/finance/private-financing/components/private-financing-list/private-financing-list.components";
import { CreditListComponent as CreditListV2Component } from "../modules_v2/finance/credit/components/credit-list/credit-list.components";
import { EmployeeCreditListComponent as EmployeeCreditListV2Component } from "../modules_v2/finance/employee-credit/components/employee-credit-list/employee-credit-list.components";
import { FinancialInvestmentListV2Component } from "../modules_v2/investment/financial-investment/components/financial-investment-list/financial-investment-list.components";
import { InvestmentAssetIntangibleListComponent } from "../modules_v2/investment/investment-asset-intangible/components/investment-asset-intangible-list/investment-asset-intangible-list.components";
import { InvestmentAssetMaterialListComponent } from "../modules_v2/investment/investment-asset-material/components/investment-asset-material-list/investment-asset-material-list.components";
import { InvestmentCompanyListComponent } from "../modules_v2/investment/investment-company/components/investment-company-list/investment-company-list.components";
import { RealStateInvestmentListComponent } from "../modules_v2/investment/real-state-investment/components/real-state-investment-list/real-state-investment-list.components";
import { TicketListV2Component } from "../modules_v2/income/ticket/components/ticket-list/ticket-list.components";
import { TicketFormV2Component } from "../modules_v2/income/ticket/components/ticket-form/ticket-form.components";
import { TicketFormComponent } from "./invoice/tickets/ticket-form.component";
import { OrdersListComponent } from "./concept/orders/orders-list.component";
import { OrdersCreateComponent } from "./concept/orders/orders-create.component";
import { DeliveryNoteFormComponent } from "./invoice/deliverynotes/deliverynote-form.component";
import { ContactListV2Component } from "../modules_v2/contacts/components/contact-list/contact-list.component";
import { LocationListComponent } from "../modules_v2/booking/locations/components/location-list/location-list.component";
import { LocationFormComponent } from "../modules_v2/booking/locations/components/location-form/location-form.component";
import { LocationDetailComponent } from "../modules_v2/booking/locations/components/location-detail/location-detail.component";
import { LocationSettingsFormComponent } from "../modules_v2/booking/locations/components/location-settings-form/location-settings-form.component";

export const CONVFACT_ROUTES: Routes = [
  {
    path: "",
    component: CoreComponent,
    canActivate: [AuthGuard],

    children: [
      {
        path: "v2/contacts",
        component: ContactFormComponent,
      },
      {
        path: "DummyComponent",
        component: DummyComponent,
      },
      {
        path: "consultant",
        component: ConsultantComponent,
      },
      {
        path: "schedule",
        component: ScheduleListComponent,
      },
      {
        path: "booking",
        component: BookingTabsComponent,
        children: [
          {
            path: "calendar",
            component: BookingCalendarComponent,
          },
          {
            path: "reports",
            component: BookingReportsComponent,
          },
          {
            path: "bookings",
            component: BookingListComponent,
          },
          {
            path: "locations",
            children: [
              {
                path: "",
                component: LocationListComponent,
              },
              {
                path: "settings/new",
                component: LocationSettingsFormComponent,
              },
              {
                path: "settings/edit/:id",
                component: LocationSettingsFormComponent,
              },
              {
                path: ":locationId",
                component: LocationDetailComponent,
              },
            ],
          },
        ],
      },
      {
        path: "agendapro",
        component: BookingCalendarComponent,
      },
      {
        path: "admin/reservas",
        children: [
          {
            path: "",
            component: LocationListComponent,
          },
          {
            path: "nuevo",
            component: LocationSettingsFormComponent,
          },
          {
            path: "editar/:id",
            component: LocationSettingsFormComponent,
          },
          {
            path: ":locationId",
            component: LocationDetailComponent,
          },
        ],
      },
      {
        path: "admin",
        component: AdminTabsComponent,
        children: [
          {
            path: "users",
            component: AdminListComponent,
          },
          {
            path: "advisors",
            component: AdvisorListComponent,
          },
          {
            path: "help",
            children: [
              {
                path: "",
                component: AdminHelpListComponent,
              },
              {
                path: "edit/:uid",
                component: AdminHelpComponent,
              },
              {
                path: "create",
                component: AdminHelpComponent,
              },
            ],
          },
          {
            path: "log",
            component: AdminLogListComponent,
          },
          {
            path: "event",
            component: AdminEventListComponent,
          },
          {
            path: "contacts",
            component: AdminContactListComponent,
          },
          {
            path: "verifactu",
            component: AdminVerifactuAuthorizationComponent,
          },
        ],
      },
      {
        path: "notification",
        component: NotificationListComponent,
      },
      {
        path: "files",
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'ficheros' },
        children: [
          {
            path: "**",
            component: FilesListComponent,
          },
        ],
      },
      {
        path: "ocrHistory",
        children: [
          {
            path: "**",
            component: OcrHistoryComponent,
          },
        ],
      },
      {
        path: "help",
        component: HelpTabsComponent,
        children: [
          {
            path: "",
            redirectTo: "entrance",
            pathMatch: "full",
          },
          {
            path: "entrance",
            component: EntranceHelpComponent,
          },
          {
            path: "expense",
            component: ExpenseHelpComponent,
          },
          {
            path: "bankaccount",
            component: BankAccountHelpComponent,
          },
        ],
      },
      {
        canActivate: [PermissionGuard],
        data: { permission: 'tpv' },
        path: "tpv",
        loadChildren: () => import('../modules_v2/tpv/tpv.module').then(m => m.TpvModule),
      },
      {
        path: "investment",
        component: InvestmenttabsComponent,
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'inversion' },
        children: [
          {
            path: "",
            redirectTo: "intangible",
            pathMatch: "full",
          },
          {
            path: "intangible",
            children: [
              {
                path: "",
                component: InvestmentAssetIntangibleListComponent,
              },
              {
                path: "create",
                redirectTo: "/investment/intangible",
                pathMatch: "full",
              },
              {
                path: "edit/:investmentUid",
                redirectTo: "/investment/intangible",
                pathMatch: "full",
              },
            ],
          },
          {
            path: "material",
            children: [
              {
                path: "",
                component: InvestmentAssetMaterialListComponent,
              },
              {
                path: "create",
                redirectTo: "/investment/material",
                pathMatch: "full",
              },
              {
                path: "edit/:investmentUid",
                redirectTo: "/investment/material",
                pathMatch: "full",
              },
            ],
          },
          {
            path: "property",
            children: [
              {
                path: "",
                component: RealStateInvestmentListComponent,
              },
              {
                path: "create",
                redirectTo: "/investment/property",
                pathMatch: "full",
              },
              {
                path: "edit/:investmentUid",
                redirectTo: "/investment/property",
              },
            ],
          },
          {
            path: "incompanies",
            children: [
              {
                path: "",
                component: InvestmentCompanyListComponent,
              },
              {
                path: "create",
                redirectTo: "",
                pathMatch: "full",
              },
              {
                path: "edit/:investmentUid",
                redirectTo: "",
                pathMatch: "full",
              },
            ],
          },
          {
            path: "financial",
            children: [
              {
                path: "",
                component: FinancialInvestmentListV2Component,
              },
              {
                path: "create",
                component: FinancialInvestmentListV2Component,
              },
              {
                path: "edit/:investmentUid",
                component: FinancialInvestmentListV2Component,
              },
            ],
          },
          /* {
  path: 'ongoing',
  children: [
    {
      path: '',
      component: InvestmentListComponent,
    },
    {
      path: 'create',
      component: InvestmentComponent,
    },
    {
      path: 'edit/:investmentUid',
      component: InvestmentComponent,
    },
  ]
}, */
        ],
      },
      {
        path: "finance",
        component: FinanzastabsComponent,
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'finanzas' },
        children: [
          {
            path: "",
            redirectTo: "bankaccounts",
            pathMatch: "full",
          },
          {
            path: "bankaccounts",
            children: [
              {
                path: "",
                component: BankAccountListV2Component,
              },
              {
                path: "edit/:uid",
                component: BankAccountComponent,
              },
              {
                path: "create",
                component: BankAccountComponent,
              },
            ],
          },
          {
            path: "cash",
            children: [
              {
                path: "",
                component: CashListV2Component,
              },
              {
                path: "cash",
                component: CashListV2Component,
              },
            ],
          },
          {
            path: "creditfacility",
            children: [
              {
                path: "",
                component: CreditPolicyListV2Component,
              },
              {
                path: "cash",
                component: CreditPolicyListV2Component,
              },
              {
                path: "conciliation",
                component: ReconciliationComponent,
              },
            ],
          },
          {
            path: "debitcard",
            children: [
              {
                path: "",
                component: DebitCardListV2Component,
              },
              {
                path: "create",
                component: PaymentCardComponent,
              },
            ],
          },
          {
            path: "reconciliation",
            loadChildren: () => import('../modules_v2/finance/reconciliation/reconciliation.module').then(m => m.ReconciliationModule),
          },
          {
            path: "creditcard",
            children: [
              {
                path: "",
                component: CreditCardListV2Component,
              },
              {
                path: "create",
                component: PaymentCardComponent,
              },
            ],
          },
          {
            path: "credits",
            component: CreditosTabsComponent,
            children: [
              {
                path: "",
                redirectTo: "creditsentity",
                pathMatch: "full",
              },
              {
                path: "creditsentity",
                children: [
                  {
                    path: "",
                    component: CreditListV2Component,
                  },
                  {
                    path: "create",
                    component: CreditosComponent,
                  },
                  {
                    path: "edit/:creditsentityUid",
                    component: CreditosComponent,
                  },
                ],
              },
              {
                path: "creditswithemployees",
                children: [
                  {
                    path: "",
                    component:
                      EmployeeCreditListV2Component,
                  },
                  {
                    path: "create",
                    component:
                      CreditosConEmpleadosComponent,
                  },
                  {
                    path: "edit/:creditswithemployeesUid",
                    component:
                      CreditosConEmpleadosComponent,
                  },
                ],
              },
            ],
          },
          {
            path: "loans",
            component: PrestamosTabsComponent,
            children: [
              {
                path: "",
                redirectTo: "banksloans",
                pathMatch: "full",
              },
              {
                path: "privatefinancing",
                children: [
                  {
                    path: "",
                    component:
                      PrivateFinancingListV2Component,
                  },
                  {
                    path: "create",
                    component: FinanciacionPrivadaComponent,
                  },
                  {
                    path: "edit/:privatefinancingUid",
                    component: FinanciacionPrivadaComponent,
                  },
                ],
              },
              {
                path: "selffinancing",
                children: [
                  {
                    path: "",
                    component:
                      OwnFinancingListV2Component,
                  },
                  {
                    path: "create",
                    component: FinanciacionPropiaComponent,
                  },
                  {
                    path: "edit/:selffinancingUid",
                    component: FinanciacionPropiaComponent,
                  },
                ],
              },
              {
                path: "banksloans",
                children: [
                  {
                    path: "",
                    component: LoanListV2Component,
                  },
                  {
                    path: "create",
                    component: PrestamosComponent,
                  },
                  {
                    path: "edit/:loanUid",
                    component: PrestamosComponent,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "subscription",
        component: SubscriptionComponent,
      },
      {
        path: "accounting",
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'contabilidad' },
        component: AccountingTabsComponent,
        children: [
          {
            path: "",
            redirectTo: "diary",
            pathMatch: "full",
          },
          {
            path: "diary",
            component: AccountingMovementsListComponent,
          },
          {
            path: "accounts",
            component: AccountingAccountsListComponent,
          },
          {
            path: "profitandloss",
            component: AccountingProfitAndLossComponent,
          },
          {
            path: "balance",
            component: AccountingBalanceSheetComponent,
          },
          {
            path: "sumas",
            component: AccountingSumasySaldosComponent,
          },
          {
            path: "import",
            component: AccountingImportComponent,
          },
          {
            path: "export",
            component: AccountingExportComponent,
          },
          {
            path: "reports",
            component: ReportTabsComponent,
            children: [
              {
                path: "total",
                component: ReportTotalComponent,
              },
              {
                path: "cash-flow",
                component: ReportCashFlowComponent,
              },
              {
                path: "working-capital",
                component: ReportWorkingCapitalComponent,
              },
              {
                path: "gross-margin",
                component: ReportGrossMarginComponent,
              },
              {
                path: "ratios",
                component: ReportRatioComponent,
              },
            ],
          },
          {
            path: "export",
            component: UserExportComponent,
          },
        ],
      },
      {
        path: "taxes",
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'fiscalidad' },
        component: TaxesTabsComponent,
        children: [
          {
            path: 'annual-summary',
            component: AnnualSumaryTabsComponent,
            children: [
              { path: '', redirectTo: 'model180', pathMatch: 'full' },
              { path: 'model180', component: Model180Component },
              { path: 'model184', component: Model184Component },
              { path: 'model193', component: Model193Component },
              { path: 'model182', component: Model182Component },
            ]
          },
          {
            path: "retencionesirpf",
            loadChildren: () => import('./taxes/retenciones-irpf.module').then(m => m.RetencionesIrpfModule),
          },
          {
            path: "quarter-tax-receipts",
            children: [
              {
                path: "",
                redirectTo: "list",
                pathMatch: "full",
              },
              {
                path: "list",
                component: QuarterlyTaxReceiptListComponent,
              },
              {
                path: "create",
                component: QuarterlyTaxReceiptComponent,
              },
              {
                path: "edit/:uid",
                component: QuarterlyTaxReceiptComponent,
              },
            ],
          },
          {
            path: "pagosfraccionados",
            loadChildren: () => import('./taxes/pagos-fraccionados.module').then(m => m.PagosFraccionadosModule),
          },
          {
            path: "impuestos",
            loadChildren: () => import('./taxes/iva-igic.module').then(m => m.IvaIgicModule),
          },
          {
            path: "rentasysociedades",
            loadChildren: () => import('./taxes/renta-sociedades.module').then(m => m.RentaSociedadesModule),
          },
          {
            path: "fiscal-closure",
            children: [
              {
                path: "",
                redirectTo: "list",
                pathMatch: "full",
              },
              {
                path: "list",
                component: FiscalClosureListComponent,
              },
            ],
          },
        ],
      },
      {
        path: "fiscalidad",
        component: FiscalTabsComponent,
        children: [
          {
            path: "",
            redirectTo: "fiscalModels",
            pathMatch: "full",
          },
          {
            path: "fiscalModels",
            component: FiscalModelComponent,
          },
        ],
      },
      {
        path: "qrcode",
        component: QRCodeComponent,
      },
      {
        path: "resume/:activityUid",
        component: ResumeComponent,
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'resumen' }
      },
      {
        path: "resume",
        component: ResumeComponent,
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'resumen' }
      },
      {
        path: "ia",
        loadChildren: () =>
          import('../modules_v2/ia/ia.module').then((m) => m.IaModule),
      },
      {
        path: "account",
        component: UserTabsComponent,
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'configuracion' },
        children: [
          {
            path: "",
            redirectTo: "contact",
            pathMatch: "full",
          },
          {
            path: "contact",
            loadChildren: () => import('../modules_v2/user-contact/user-contact-v2.module').then(m => m.UserContactV2Module),
          },
          {
            path: "billing",
            component: UserBillingListComponent,
          },
          {
            path: "logo",
            component: UserLogoComponent,
          },
          {
            path: "company",
            loadChildren: () => import('../modules_v2/user-company/user-company-v2.module').then(m => m.UserCompanyV2Module),
          },
          {
            path: "stock",
            component: UserStockComponent,
          },
          {
            path: "activity",
            loadChildren: () => import('../modules_v2/user-activity/user-activity-v2.module').then(m => m.UserActivityV2Module),
          },
          {
            path: "verifactu",
            loadChildren: () => import('../modules_v2/verifactu/verifactu.module').then(m => m.VerifactuModule),
          },
          /*  {
   path: 'accountingmodel',
   children: [
     {
       path: '',
       component: AccountingModelListComponent,
     },
     {
       path: 'create',
       component: AccountingModelComponent,
     },
     {
       path: 'edit/:accountingModelUid',
       component: AccountingModelComponent,
     },
     {
       path: 'import',
       component: AccountingModelImportComponent,
     }
   ]
 }, */
          /* {
  path: 'mandate',
  children: [
    {
      path: '',
      component: MandateListComponent,
    },
    {
      path: 'create',
      component: MandateComponent,
    },
    {
      path: 'edit/:mandateUid',
      component: MandateComponent,
    },
  ]
}, */
        ],
      },
      {
        path: "partnersequity",
        component: PartnersequityComponent,
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'socios' },
        children: [
          {
            path: "",
            redirectTo: "partners",
            pathMatch: "full",
          },
          {
            path: "partners",
            loadChildren: () => import('../modules_v2/partnersequity/partners/partners.module').then(m => m.PartnerV2Module),
          },
          {
            path: "capital-social",
            loadChildren: () => import('../modules_v2/partnersequity/social-capital/social-capital.module').then(m => m.SocialCapitalV2Module),
          },
          {
            path: "reserve",
            loadChildren: () => import('../modules_v2/partnersequity/reserve/reserve.module').then(m => m.ReserveV2Module),
          },
          {
            path: "related-companies",
            loadChildren: () => import('../modules_v2/partnersequity/related-companies/related-companies.module').then(m => m.RelatedCompaniesV2Module),
          },
        ],
      },
      {
        path: "expense",
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'gastos' },
        component: ExpenseTabsComponent,
        children: [
          {
            path: "",
            redirectTo: "list",
            pathMatch: "full",
          },
          {
            path: "select",
            component: ExpenseSelectorComponent,
          },
          {
            path: "list",
            loadChildren: () => import('../modules_v2/expense/expenses/expenses.module').then(m => m.ExpensesV2Module),
          },
          {
            path: "create",
            loadChildren: () => import('../modules_v2/expense/expense-form/expense-form.module').then(m => m.ExpenseFormV2Module),
          },
          {
            path: "edit/:uid",
            loadChildren: () => import('../modules_v2/expense/expense-form/expense-form.module').then(m => m.ExpenseFormV2Module),
          },
          {
            path: "create-old",
            component: ExpenseComponent,
          },
          {
            path: "edit-old/:uid",
            component: ExpenseComponent,
          },
          {
            path: "salary",
            children: [
              {
                path: "",
                loadChildren: () => import('../modules_v2/expense/payroll/payroll.module').then(m => m.PayrollModule),
              },
              {
                path: "create",
                loadChildren: () => import('../modules_v2/expense/payroll-form/payroll-form.module').then(m => m.PayrollFormV2Module),
              },
              {
                path: "edit/:salaryUid",
                loadChildren: () => import('../modules_v2/expense/payroll-form/payroll-form.module').then(m => m.PayrollFormV2Module),
              },
              {
                path: "create-old",
                component: SalaryComponent,
              },
              {
                path: "edit-old/:salaryUid",
                component: SalaryComponent,
              },
            ],
          },
          {
            path: "selfemployed",
            children: [
              {
                path: "",
                loadChildren: () => import('../modules_v2/expense/self-employed/self-employeed.module').then(m => m.SelfEmployeedModule),
              },
              {
                path: "create",
                loadChildren: () => import('../modules_v2/expense/self-employed-form/self-employed-form.module').then(m => m.SelfEmployedFormV2Module),
              },
              {
                path: "edit/:selfEmployedUid",
                loadChildren: () => import('../modules_v2/expense/self-employed-form/self-employed-form.module').then(m => m.SelfEmployedFormV2Module),
              },
              {
                path: "create-old",
                component: SelfEmployedComponent,
              },
              {
                path: "edit-old/:selfEmployedUid",
                component: SelfEmployedComponent,
              },
            ],
          },
          {
            path: "bankcharges",
            children: [
              {
                path: "",
                loadChildren: () => import('../modules_v2/expense/bank-charge/bank-charge.module').then(m => m.BankChargeModule),
              },
              {
                path: "create",
                loadChildren: () => import('../modules_v2/expense/bank-charge-form/bank-charge-form.module').then(m => m.BankChargeFormV2Module),
              },
              {
                path: "edit/:bankChargesUid",
                loadChildren: () => import('../modules_v2/expense/bank-charge-form/bank-charge-form.module').then(m => m.BankChargeFormV2Module),
              },
              {
                path: "create-old",
                component: BankChargesComponent,
              },
              {
                path: "edit-old/:bankChargesUid",
                component: BankChargesComponent,
              },
            ],
          },

          {
            path: "advancepayment",
            component: AdvancePaymentTabsComponent,
            children: [
              {
                path: "provider",
                loadChildren: () => import('../modules_v2/expense/supplier-advance/supplier-advance.module').then(m => m.SupplierAdvanceModule),
              },
              {
                path: "create",
                component: CustomerAdvancePaymentFormV2Component,
                data: { mode: 'supplier' },
              },
              {
                path: "edit/:uid",
                component: CustomerAdvancePaymentFormV2Component,
                data: { mode: 'supplier' },
              },
              {
                path: "create-old",
                component: AdvancePaymentComponent,
              },
              {
                path: "edit-old/:uid",
                component: AdvancePaymentComponent,
              },
              {
                path: "bail",
                children: [
                  {
                    path: "",
                    loadChildren: () => import('../modules_v2/expense/bail/bail.module').then(m => m.BailModule),
                  },
                  {
                    path: "create",
                    component: CustomerAdvancePaymentFormV2Component,
                    data: { mode: 'bail' },
                  },
                  {
                    path: "edit/:uid",
                    component: CustomerAdvancePaymentFormV2Component,
                    data: { mode: 'bail' },
                  },
                  {
                    path: "create-old",
                    component: BailComponent,
                  },
                  {
                    path: "edit-old/:uid",
                    component: BailComponent,
                  },
                ],
              },
            ],
          },
          {
            path: "irpf",
            loadChildren: () => import('../modules_v2/expense/irpf-list/irpf-list.module').then(m => m.IrpfListModule),
          },
          {
            path: "statistics",
            loadChildren: () => import('../modules_v2/expense/statistics/expense-statistics.module').then(m => m.ExpenseStatisticsV2Module),
          },

          {
            path: "ia",
            children: [
              {
                path: "",
                component: IAGastosComponent,
              },
            ],
          },

          {
            path: "correos-ia",
            children: [
              {
                path: "",
                component: CorreosIAComponent,
              },
            ],
          },
        ],
      },

      {
        path: "invoice",
        component: InvoiceTabsComponent,
        canActivate: [FeeGuard],
        children: [
          {
            path: "",
            redirectTo: "preinvoice",
            pathMatch: "full",
          },
          // {
          //   path: "issued",
          //   canActivate: [FeeGuard, PermissionGuard],
          //   data: { permission: 'ingresosFacturas' },
          //   component: InvoiceListIssuedComponent,
          // },
          {
            path: "issued",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosFacturas' },
            loadChildren: () => import('../modules_v2/income/invoice/invoice.module').then(m => m.InvoiceModule),
          },

          {
            path: "work-orders",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosOrdenesTrabajo' },
            loadChildren: () => import('../modules_v2/income/work-order/work-order.module').then(m => m.WorkOrderModule),
          },
          {
            path: "analisis-ingresos",
            component: AnalisisIngresosComponent,
          },
          {
            path: "irpf/:trimester",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosIrpfCuenta' },
            children: [
              {
                path: "",
                component: IrpfInvoiceListComponent,
              },
            ],
          },
          {
            path: "subvention",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosSubvenciones' },
            children: [
              {
                path: "",
                component: GrantListComponent,
              },
              {
                path: "edit/:uid",
                component: GrantFormV2Component,
              },
              {
                path: "create",
                component: GrantFormV2Component,
              },
            ],
          },

          {
            path: "recurrents",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosRecurrentes' },
            children: [
              {
                path: "",
                component: RecurrentListV2Component,
              },
              {
                path: "create",
                component: RecurrentFormV2Component,
              },
              {
                path: "edit/:uid",
                component: RecurrentFormV2Component,
              },
            ],
          },
          {
            path: "bookings",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosRecurrentes' },
            children: [
              {
                path: "",
                component: BookingCalendarComponent,
              },
            ],
          },
          {
            path: "deliverynote",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosAlbaranes' },
            loadChildren: () => import('../modules_v2/income/delivery-note/delivery-note.module').then(m => m.DeliveryNoteModule),
          },
          {
            path: "certificate",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosCertificates' },
            loadChildren: () => import('../modules_v2/income/certificate/certificate.module').then(m => m.CertificateModule),
          },
          {
            path: "preinvoice",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosPresupuestos' },
            loadChildren: () => import('../modules_v2/income/preinvoice/preinvoice.module').then(m => m.PreinvoiceModule),
          },
          // {
          //   path: "ticket",
          //   canActivate: [FeeGuard, PermissionGuard],
          //   data: { permission: 'ingresosTickets' },
          //   children: [
          //     {
          //       path: "create",
          //       component: TicketComponent,
          //     },
          //     {
          //       path: "edit/:uid",
          //       component: TicketComponent,
          //     },
          //     {
          //       path: "",
          //       component: TicketListComponent,
          //     },
          //   ],
          // },
          {
            path: "ticket",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosTickets' },
            children: [
              {
                path: "create",
                component: TicketFormV2Component,
              },
              // {
              //   path: "edit/:uid",
              //   component: TicketComponent,
              // },
              {
                path: "",
                component: TicketListV2Component,
              },
            ],
          },
          {
            path: "advancepaymentinvoice",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosAnticipos' },
            children: [
              {
                path: "",
                component: CustomerAdvancePaymentListComponent,
              },
              {
                path: "create",
                component: CustomerAdvancePaymentFormV2Component,
              },
              {
                path: "edit/:uid",
                component: CustomerAdvancePaymentFormV2Component,
              },
            ],
          },
          {
            path: "financialincome",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosFinancieros' },
            children: [
              {
                path: "",
                component: FinancialIncomeListV2Component,
              },
              {
                path: "create",
                component: FinancialIncomeFormV2Component,
              },
              {
                path: "edit/:financialIncomeUid",
                component: FinancialIncomeFormV2Component,
              },
            ],
          },
          {
            path: "statistics",
            canActivate: [FeeGuard, PermissionGuard],
            data: { permission: 'ingresosEstadisticas' },
            children: [
              {
                path: "",
                component: InvoiceStatisticsComponent,
              },
            ],
          },
        ],
      },
      {
        path: "conceptimport",
        component: ConceptImportComponent,
        canActivate: [FeeGuard],
      },
      {
        path: "concept",
        component: ConceptTabsComponent,
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'productos' },
        children: [
          {
            path: "",
            redirectTo: "edit",
            pathMatch: "full",
          },
          {
            path: "edit",
            loadChildren: () => import('../modules_v2/concept/concept/concept.module').then(m => m.ConceptV2Module),
          },
          {
            path: "edit/:uid",
            redirectTo: "edit",
          },
          {
            path: "create",
            redirectTo: "edit",
          },
          {
            path: "orders",
            loadChildren: () => import('../modules_v2/concept/purchase-order/purchase-order.module').then(m => m.PurchaseOrderV2Module),
          },
          {
            path: "salesreport",
            loadChildren: () => import('../modules_v2/concept/sales-report/sales-report.module').then(m => m.SalesReportV2Module),
          },
          {
            path: "vouchers",
            loadChildren: () => import('../modules_v2/service/vouchers/vouchers.module').then(m => m.VouchersModule),
          },

          {
            path: "conceptfamily",
            children: [
              {
                path: "",
                loadChildren: () => import('../modules_v2/concept/concept-family/concept-family.module').then(m => m.ConceptFamilyV2Module),
              },
              {
                path: "edit/:uid",
                redirectTo: "",
                pathMatch: "full",
              },
              {
                path: "create/:uid",
                redirectTo: "",
                pathMatch: "full",
              },
            ],
          },

          {
            path: "conceptcontact",
            children: [
              {
                path: "",
                component: ConceptContactListComponent,
              },
              {
                path: "edit/:uid",
                component: ConceptContactComponent,
              },
              {
                path: "create",
                component: ConceptContactComponent,
              },
            ],
          },
          {
            path: "controlstock",
            children: [
              {
                path: "",
                component: ControlStockListComponent,
              },
              {
                path: "create",
                component: ControlStockComponent,
              },
              {
                path: "edit/:controlstockUid",
                component: ControlStockComponent,
              },
            ],
          },
          {
            path: "statistics",
            loadChildren: () => import('../modules_v2/concept/concept-statistics/concept-statistics.module').then(m => m.ConceptStatisticsV2Module),
          },


        ],
      },
      {
        path: "contactimport",
        component: ContactImportComponent,
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'contactos' }
      },
      {
        path: "contact",
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'contactos' },
        children: [
          {
            path: "",
            component: ContactListV2Component,
          },
          {
            path: ":contactUid",
            component: ContactTabsComponent,
            children: [
              {
                path: "edit",
                component: ContactFormRouteComponent,
              },
              {
                path: "bank-accounts",
                component: ContactBankAccountListComponent,
              },
              {
                path: "bank-accounts/:bankAccountUid",
                component: ContactBankAccountComponent,
              },
              {
                path: "bank-accounts/create",
                component: ContactBankAccountComponent,
              },
              {
                path: "center",
                component: CenterListComponent,
              },
              {
                path: "center/:centerUid",
                component: CenterComponent,
              },
              {
                path: "center/create",
                component: CenterComponent,
              },
            ],
          },
          {
            path: "create",
            component: ContactFormRouteComponent,
          },
        ],
      },
      {
        path: "employees",
        component: EmployeestabsComponent,
        canActivate: [FeeGuard, PermissionGuard],
        data: { permission: 'personal' },
        children: [
          {
            path: "",
            redirectTo: "list",
            pathMatch: "full",
          },
          {
            path: "list",
            loadChildren: () => import('../modules_v2/personal/employees/employees.module').then(m => m.EmployeesV2Module),
          },
          {
            path: "gastos",
            component: GastosComponent,
          },
          {
            path: "turnos",
            component: TurnosComponent,
          },
          {
            path: "bajas",
            component: BajasComponent,
          },
          {
            path: "vacaciones",
            component: VacacionesComponent,
          },
          {
            path: "asuntos-propios",
            component: AsuntosPropiosComponent,
          },
          {
            path: "tiempo",
            component: TiempoComponent,
          },
          {
            path: "childUsers",
            component: ChildUsersComponent
          }
        ],
      },

      {
        path: "support",
        component: SupportTicketsComponent,
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent
      },
      {
        path: "projects",
        loadChildren: () =>
          import('../modules_v2/projects/projects.module').then(
            (m) => m.ProjectsModule
          ),
      },
    ],
  },
  {
    path: "login/:uid",
    component: LoginComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "register",
    component: RegisterComponent,
  },
  {
    path: "forgot",
    component: ForgotComponent,
  },
  {
    path: "forgot/:uid",
    component: ForgotComponent,
  },
  {
    path: "logout",
    component: LogoutComponent,
  },
  {
    path: "developers",
    component: DevelopersComponent,
  },
  {
    path: "**",
    component: NotFoundComponent,
  },

];
